// Central site configuration — edit content, links, CTAs and imagery here.
// IMAGERY: one cohesive generated editorial campaign (photorealistic placeholder
// imagery). To replace with real UniversHeal/hospital photography later, swap URLs
// here only — no component changes needed.

export const IMG = {
    // Consultations & sections
    hero: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/be5cd0929166c62814be4bda689b0c15106c6c2ad7b390f8a1076e7b1ee6f2c7.jpeg",
    difference: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/3fa764f3143ce6ec04abdea396897c77f7b31d41e2e3e0e91ac165e46078dbcf.jpeg",
    cardiology: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/e7fbf0e1d333d1f326453af434a0e8f138cbdea31c2a6a80c9e7c82fb2e5bcae.jpeg",
    ortho: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/b6e78bce7e9aa5513948cebe020c9af1017ea559c92e448ce61c9eb4cd100a3f.jpeg",
    oncology: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/9646c20b17547b84641b4c58d8103622ab62dc09e1ff0139436b3b2ecb43745a.jpeg",
    fertility: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/e061ff2ed0805714e3053e98b1910c5d82a193eafc6769f184e62ebcb80a3afb.jpeg",
    secondOpinion: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/c5089959e8be04e1745a0f9715685147278036f9939350b8b426eb908cf2bd23.jpeg",
    planning: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/de0ad7ad7ad9428e70b6fb0165654740f225b5d403f0611a99345cb6571cabd1.jpeg",
    coordinator: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/5c15c67fbf4c56be777e2f2017df3cb4195aed136f19882214272d52255d3ce6.jpeg",
    aboutCare: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/b47e7a3333f16378381ae6aea14ebf45e3fa9a851dd326c8d087c80eb09380cc.jpeg",
    recoveryRoom: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/168e528c77fdcade0bb344b4608d3ab687ae20988f9b62f62f5d2a8cfbe4f621.jpeg",
    // Journey
    journeyEnquiry: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/868d073cabe794c3f090106b5bce1e907aee700863c06a7da925e46e582dc246.jpeg",
    journeyVideo: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/de234f98a6fb211f192e6f36f63957b4fa603922acb7a892b94687dac0659874.jpeg",
    journeyTravel: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/2f8ce265f78b6ce520167834c8877b941ad1056cf734e9feb57008917c001cb2.jpeg",
    journeyRecovery: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/1bea0f7eb0ca6e993c28e1ed16c90ad52c9c9af5864cfb835c38d2c8ab0e113d.jpeg",
    journeyFollowup: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/3bcf30779d530eec7dd83fa10265802a380bef360b9304a3c3b559575ed0c2d5.jpeg",
    // Kerala — God's Own Country
    keralaMunnar: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/ed917ef23701bd0cb47380bd133f173741288d981ea8ce586adedb10267bf8a4.jpeg",
    keralaMist: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/09e1577059dc24796acfe63767797db85deacd329ca5a32a433165b3d9ba4871.jpeg",
    keralaBackwaters: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/119ca0bae7ae01899b14a405d4967d4e821d8f49dcb1fdfd153f530451925a14.jpeg",
    keralaGhats: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/6aac9adcf6d29929e9600d28c3c6eef94e88fe638def25f8bb326dff0fe8e7a7.jpeg",
    keralaArchitecture: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/545ddf8dee117e2d5d7994efd6f8906c211cc4a4cf2a71e734be1e235afb6641.jpeg",
    keralaCoast: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/d226dc3a79a334825592b090b73c3ac7ae0fc5a7b2b490b75f422bde2aaf9fad.jpeg",
    // Modern healthcare infrastructure
    hospitalExterior: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/bf3992fe9811965ad14def297b65d60d6d8f6e7cff1c37792361b5564eeea1e3.jpeg",
    hospitalOT: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/56df8249b53534fbc0cf1df9a92d18091ed79d0182a58b74ec680f3d4d9aea25.jpeg",
    hospitalImaging: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/41ce133fbb0f2c9ba96de95fcbef3231547f92fcddc3d47c1ae06ac2348558be.jpeg",
    hospitalLab: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/4b429162f1e5eb4a0dd60f50ed82d835afa1620f9099439f5d90985fd2626516.jpeg",
    hospitalCorridor: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/4f926c01069428811b1cd114a440bb8a2f5df5866159d407206916e84db8deda.jpeg",
    hospitalRoom: "https://static.prod-images.emergentagent.com/jobs/7727f199-c592-4e44-b4d0-cd79a84c287a/images/2580c46c3aef5496f5925fc9b579fe4b9d82d2999abbf484c7c9c826ad1a362a.jpeg",
};

export const SITE = {
    name: "UniversHeal",
    tagline: "People. Care. Beyond Borders.",
    // PLACEHOLDER — replace with the official WhatsApp business number before launch.
    whatsappUrl: "https://wa.me/000000000000",
    emailDisplay: "[Email address — placeholder]",
    phoneDisplay: "[Phone number — placeholder]",
    officeDisplay: "Kerala, India — [Full address — placeholder]",
    // PLACEHOLDER — configure the maximum accepted upload size for the opinion form.
    maxUploadMb: 10,
};

export const NAV_LINKS = [
    { label: "Medical Care", path: "/medical-care" },
    { label: "Wellness", path: "/wellness" },
    { label: "Ayurveda", path: "/ayurveda" },
    { label: "Hospitals", path: "/hospitals" },
    { label: "Why UniversHeal", path: "/why-universheal" },
    { label: "Your Journey", path: "/your-journey" },
    { label: "Why Kerala", path: "/why-kerala" },
    { label: "About", path: "/about" },
];

// The three complementary areas of care — medical remains the primary brand.
export const THREE_WAYS = [
    {
        title: "Medical Care",
        desc: "Access specialist healthcare and coordinated treatment pathways through carefully selected healthcare providers in India.",
        items: [
            "Specialist care",
            "Medical opinions",
            "Second opinions",
            "Treatment planning",
            "Hospital coordination",
            "International patient support",
        ],
        cta: "Explore Medical Care",
        path: "/medical-care",
        img: "difference",
        imgAlt: "An experienced Indian doctor warmly consulting an international patient in a modern clinic",
        testid: "three-ways-medical",
    },
    {
        title: "Wellness",
        desc: "Personalised wellness journeys designed around restoration, lifestyle, wellbeing and healthy living.",
        items: [
            "Wellness retreats",
            "Yoga",
            "Meditation",
            "Nutrition",
            "Lifestyle programs",
            "Stress and recovery",
            "Preventive wellness",
        ],
        cta: "Explore Wellness",
        path: "/wellness",
        img: "keralaGhats",
        imgAlt: "The green Western Ghats mountains of Kerala rising over misty valleys",
        testid: "three-ways-wellness",
    },
    {
        title: "Ayurveda",
        desc: "Experience traditional Ayurvedic care and rejuvenation through qualified providers and carefully selected centres in India.",
        items: [
            "Ayurvedic consultations",
            "Rejuvenation programs",
            "Panchakarma",
            "Ayurvedic therapies",
            "Ayurveda and yoga",
            "Ayurveda and nutrition",
            "Wellness retreats",
        ],
        cta: "Explore Ayurveda",
        path: "/ayurveda",
        img: "keralaArchitecture",
        imgAlt: "Traditional Kerala architecture with warm lamps beside a calm courtyard",
        testid: "three-ways-ayurveda",
    },
];

export const WELLNESS_CATEGORIES = [
    { title: "Rest & Rejuvenation", desc: "Time to slow down, rest properly and restore your energy." },
    { title: "Yoga & Meditation", desc: "Guided practice for body and mind, from gentle beginnings to dedicated practice." },
    { title: "Nutrition & Healthy Living", desc: "Practical, personalised guidance for eating and living well." },
    { title: "Stress & Lifestyle", desc: "Programs that address the pace and pressures of everyday life." },
    { title: "Fitness & Movement", desc: "Movement tailored to your level, goals and comfort." },
    { title: "Preventive Wellness", desc: "Looking after your health before problems arise." },
    { title: "Sleep & Recovery", desc: "Restoring deep, restful sleep and genuine recovery." },
    { title: "Wellness Retreats", desc: "Longer, immersive stays designed entirely around restoration." },
];

export const WHY_INDIA_WELLNESS = [
    {
        title: "Diverse wellness traditions",
        desc: "India is home to a wide range of wellness traditions — from yoga and meditation to nutrition and restorative retreat practices.",
    },
    {
        title: "Experienced practitioners",
        desc: "Wellness programs are led by experienced practitioners, many from families and lineages where these practices are a way of life.",
    },
    {
        title: "Genuine hospitality",
        desc: "A culture of caring for guests — Athithi Devo Bhava — shapes how visitors are looked after.",
    },
    {
        title: "Nature and setting",
        desc: "From the Western Ghats to the backwaters and the coast, restorative natural settings are part of the experience.",
    },
    {
        title: "Personalised programs",
        desc: "Wellness experiences are shaped around your goals, pace and comfort — not a fixed schedule.",
    },
    {
        title: "Cultural richness",
        desc: "Heritage, cuisine and daily culture make a wellness stay memorable beyond the program itself.",
    },
];

export const AYURVEDA_EXPERIENCES = [
    { title: "Ayurvedic Consultation", desc: "A traditional consultation to understand your constitution, lifestyle and goals." },
    { title: "Rejuvenation Programs", desc: "Restorative programs designed around rest, nourishment and renewal." },
    { title: "Panchakarma", desc: "The classical, multi-stage Ayurvedic program — undertaken only under the guidance of qualified practitioners." },
    { title: "Traditional Therapies", desc: "Time-honoured therapies using herbal oils and traditional techniques." },
    { title: "Ayurveda & Yoga", desc: "Complementary daily practice combining Ayurvedic lifestyle with yoga." },
    { title: "Ayurveda & Nutrition", desc: "Ayurvedic dietary guidance shaped around your constitution and preferences." },
    { title: "Stress & Wellbeing", desc: "Programs focused on rest, mental calm and everyday balance." },
    { title: "Longer Wellness Retreats", desc: "Extended stays that allow traditions to be experienced properly, at an unhurried pace." },
];

export const AYURVEDA_JOURNEY = [
    { number: "01", title: "Tell us what you are looking for", desc: "Share your goals, interests and any health considerations." },
    { number: "02", title: "Understand your goals", desc: "We help you clarify what kind of experience would serve you best." },
    { number: "03", title: "Explore suitable providers/programs", desc: "We identify appropriately qualified providers and programs that match." },
    { number: "04", title: "Plan your stay", desc: "Travel, stay and program schedule — coordinated for you." },
    { number: "05", title: "Begin your experience", desc: "Your program begins, with a point of contact throughout." },
    { number: "06", title: "Continue with follow-up/support where appropriate", desc: "We stay available after your stay for questions and next steps." },
];

// Three journey pathways — medical, wellness and Ayurvedic.
export const JOURNEY_PATHWAYS = [
    {
        id: "medical",
        label: "Medical Journey",
        tagline: "For treatment and specialist care",
        steps: ["Enquiry", "Medical Review", "Specialist/Hospital Matching", "Treatment Plan", "Travel", "Treatment", "Recovery", "Follow-up"],
        testid: "pathway-medical",
    },
    {
        id: "wellness",
        label: "Wellness Journey",
        tagline: "For rest, lifestyle and preventive wellness",
        steps: ["Goals", "Program Matching", "Wellness Planning", "Travel & Stay", "Wellness Experience", "Continued Support"],
        testid: "pathway-wellness",
    },
    {
        id: "ayurveda",
        label: "Ayurveda Journey",
        tagline: "For traditional Ayurvedic care",
        steps: ["Goals", "Ayurvedic Consultation", "Provider/Program Matching", "Travel & Stay", "Ayurvedic Experience", "Follow-up"],
        testid: "pathway-ayurveda",
    },
];

export const TRUST_POINTS = [
    "Trusted specialists and hospitals",
    "Transparent information & costs",
    "End-to-end care coordination",
    "Support before, during & after treatment",
];

export const DIFFERENCE_CARDS = [
    {
        title: "Experienced Medical Coordination",
        desc: "Connect patients with appropriate specialists and healthcare providers.",
        icon: "compass",
    },
    {
        title: "Personal Care Coordination",
        desc: "A dedicated point of contact throughout the journey.",
        icon: "user",
    },
    {
        title: "Clear Information",
        desc: "Help patients understand consultations, treatment options and planning.",
        icon: "book",
    },
    {
        title: "Support Beyond the Hospital",
        desc: "Assistance before travel, during treatment and through recovery and follow-up.",
        icon: "shield",
    },
];

export const HOW_IT_WORKS = [
    {
        number: "01",
        title: "Share your case",
        desc: "Tell us about your condition and upload relevant medical reports.",
        icon: "file",
    },
    {
        number: "02",
        title: "Meet the right specialist",
        desc: "We help coordinate an appropriate specialist consultation.",
        icon: "user",
    },
    {
        number: "03",
        title: "Plan your treatment",
        desc: "Understand the recommended treatment pathway and practical requirements.",
        icon: "calendar",
    },
    {
        number: "04",
        title: "Travel with confidence",
        desc: "We coordinate the necessary parts of your healthcare journey in India.",
        icon: "plane",
    },
];

export const SPECIALTIES = [
    {
        slug: "cardiology",
        name: "Cardiology",
        tagline: "Expert care for a healthier, stronger heart.",
        desc: "Coordinated cardiac consultations, second opinions and treatment planning with experienced specialists.",
        icon: "heart",
        img: "cardiology",
        imgAlt:
            "An Indian cardiologist reviewing a live echocardiogram on a large monitor with an older international patient",
    },
    {
        slug: "orthopaedics",
        name: "Orthopaedics",
        tagline: "Move better. Live fuller.",
        desc: "Coordinated care for joint, spine and mobility concerns — from imaging review to surgical opinion.",
        icon: "bone",
        img: "ortho",
        imgAlt:
            "A young Indian orthopaedic specialist explaining a knee X-ray to an older international patient",
    },
    {
        slug: "oncology",
        name: "Oncology",
        tagline: "Expert care. More tomorrows.",
        desc: "Sensitive, structured coordination for oncology opinions, treatment planning and follow-up.",
        icon: "ribbon",
        img: "oncology",
        imgAlt:
            "A senior Indian oncologist speaking compassionately with an international patient in a calm cancer-care lounge",
    },
    {
        slug: "fertility",
        name: "Fertility",
        tagline: "Expert support for new beginnings.",
        desc: "Discreet, compassionate coordination for fertility consultations and reproductive care.",
        icon: "flower",
        img: "fertility",
        imgAlt:
            "An Indian fertility specialist consulting with an international couple in a premium clinic",
    },
];

export const WHY_KERALA_POINTS = [
    {
        title: "Advanced healthcare infrastructure",
        desc: "Modern hospitals, advanced diagnostics and internationally experienced clinical teams across the state.",
    },
    {
        title: "Experienced medical professionals",
        desc: "Deeply experienced specialists and a strong, respected nursing tradition.",
    },
    {
        title: "International patient services",
        desc: "Hospitals accustomed to caring for patients from abroad — with the services to match.",
    },
    {
        title: "International connectivity",
        desc: "Multiple international airports connecting Kerala directly to the Gulf, Asia and beyond.",
    },
    {
        title: "Hospitality infrastructure",
        desc: "A wide choice of premium hotels, serviced apartments and guest stays for patients and family.",
    },
    {
        title: "A supportive recovery environment",
        desc: "A calm, green and welcoming setting that supports rest, recovery and follow-up care.",
    },
];

export const TIMELINE_STEPS = [
    {
        title: "Enquiry",
        desc: "Tell us about your case",
        img: "journeyEnquiry",
        imgAlt: "An international patient completing a medical enquiry at home",
    },
    {
        title: "Consultation",
        desc: "Discuss your case with an Indian specialist",
        img: "journeyVideo",
        imgAlt: "An international patient on a video consultation with an Indian doctor",
    },
    {
        title: "Treatment Plan",
        desc: "Review your options, step by step",
        img: "planning",
        imgAlt: "An Indian doctor and an international couple reviewing a treatment plan",
    },
    {
        title: "Travel to Kerala",
        desc: "Logistics coordinated for you",
        img: "journeyTravel",
        imgAlt: "International travellers walking through a premium airport with tropical light",
    },
    {
        title: "Hospital Care",
        desc: "Advanced care, fully supported",
        img: "hospitalRoom",
        imgAlt: "A premium modern patient room in an Indian hospital at dusk",
    },
    {
        title: "Recovery & Support",
        desc: "Rest, with assistance nearby",
        img: "journeyRecovery",
        imgAlt: "A patient recovering comfortably with a view of a green Kerala courtyard",
    },
    {
        title: "Return Home & Follow-up",
        desc: "Care that continues after",
        img: "journeyFollowup",
        imgAlt: "A patient at home smiling during a follow-up video call with her Indian doctor",
    },
];

export const COORDINATION_GROUPS = [
    {
        title: "Before You Travel",
        img: "secondOpinion",
        imgAlt: "An Indian senior specialist reviewing digital medical reports with an international patient",
        items: [
            "Medical enquiry",
            "Specialist consultation",
            "Second opinion",
            "Treatment planning",
        ],
    },
    {
        title: "Travel",
        img: "journeyTravel",
        imgAlt: "International travellers walking through a bright premium airport terminal",
        items: [
            "Visa guidance",
            "Airport transfer coordination",
            "Accommodation coordination",
            "Local support",
        ],
    },
    {
        title: "During Treatment",
        img: "hospitalCorridor",
        imgAlt: "A bright modern hospital corridor with tropical garden views",
        items: [
            "Hospital coordination",
            "Appointments",
            "Diagnostics",
            "Patient support",
        ],
    },
    {
        title: "After Treatment",
        img: "recoveryRoom",
        imgAlt: "A serene premium recovery room overlooking a green Kerala courtyard",
        items: [
            "Discharge coordination",
            "Recovery support",
            "Follow-up",
            "Communication with your home country",
        ],
    },
];

// DEMO DATA — clearly-marked placeholders. Replace with verified partner profiles.
export const HOSPITALS = [
    {
        slug: "partner-hospital-a-kochi",
        name: "Partner Hospital A",
        location: "Kochi, Kerala",
        type: "Multi-specialty",
        specialties: ["Cardiology", "Orthopaedics", "Oncology"],
        accreditation: "To be verified",
        image: "hospitalExterior",
        desc: "A modern multi-specialty provider in Kochi. [Demo profile — description will be replaced with verified partner information.]",
    },
    {
        slug: "partner-hospital-b-thiruvananthapuram",
        name: "Partner Hospital B",
        location: "Thiruvananthapuram, Kerala",
        type: "Super-specialty",
        specialties: ["Cardiology", "Oncology", "Fertility"],
        accreditation: "To be verified",
        image: "hospitalImaging",
        desc: "A super-specialty centre in the state capital. [Demo profile — description will be replaced with verified partner information.]",
    },
    {
        slug: "partner-hospital-c-kozhipode",
        name: "Partner Hospital C",
        location: "Kozhikode, Kerala",
        type: "Multi-specialty",
        specialties: ["Orthopaedics", "Oncology"],
        accreditation: "To be verified",
        image: "hospitalLab",
        desc: "A trusted provider serving northern Kerala. [Demo profile — description will be replaced with verified partner information.]",
    },
    {
        slug: "partner-hospital-d-kochi",
        name: "Partner Hospital D",
        location: "Kochi, Kerala",
        type: "Specialty institute",
        specialties: ["Cardiology"],
        accreditation: "To be verified",
        image: "hospitalOT",
        desc: "A focused surgical sciences institute. [Demo profile — description will be replaced with verified partner information.]",
    },
    {
        slug: "partner-hospital-e-thrissur",
        name: "Partner Hospital E",
        location: "Thrissur, Kerala",
        type: "Multi-specialty",
        specialties: ["Orthopaedics", "Fertility"],
        accreditation: "To be verified",
        image: "hospitalRoom",
        desc: "A community-rooted multi-specialty hospital. [Demo profile — description will be replaced with verified partner information.]",
    },
    {
        slug: "partner-hospital-f-thiruvananthapuram",
        name: "Partner Hospital F",
        location: "Thiruvananthapuram, Kerala",
        type: "Specialty institute",
        specialties: ["Fertility"],
        accreditation: "To be verified",
        image: "hospitalCorridor",
        desc: "A dedicated women's health and fertility centre. [Demo profile — description will be replaced with verified partner information.]",
    },
];

export const HOSPITAL_TYPES = [
    "Multi-specialty",
    "Super-specialty",
    "Specialty institute",
];

// Destinations — India-first positioning. Kerala is the only live destination;
// future cities are listed as "upcoming" and must never be presented as live.
export const DESTINATIONS = [
    {
        slug: "kerala",
        name: "Kerala",
        status: "live",
        tagline: "Our first destination",
        img: "keralaMist",
        imgAlt:
            "Mist-covered Western Ghats mountains rising over a deep green Kerala valley",
        intro:
            "Kerala, God's Own Country, combines advanced healthcare, experienced medical professionals and warm hospitality within a peaceful and naturally beautiful environment.",
    },
    { slug: "bengaluru", name: "Bengaluru", status: "upcoming" },
    { slug: "hyderabad", name: "Hyderabad", status: "upcoming" },
    { slug: "delhi", name: "Delhi NCR", status: "upcoming" },
    { slug: "mumbai", name: "Mumbai", status: "upcoming" },
    { slug: "chennai", name: "Chennai", status: "upcoming" },
];

// Searchable, category-based FAQ for international patients.
export const FAQ_CATEGORIES = [
    {
        title: "Travel & Visa",
        items: [
            {
                q: "Can you help with a medical visa?",
                a: "We guide you through the process and coordinate the documentation and information you may need for medical travel. Visa decisions always rest with the relevant authorities.",
            },
            {
                q: "How long should I plan to stay in Kerala?",
                a: "It depends on your treatment pathway and your treating doctors' advice. Once your consultation and treatment plan are clear, we help you plan an appropriate stay.",
            },
            {
                q: "Do you arrange flights?",
                a: "We provide travel planning support and coordinate with trusted local partners. Flight bookings are made directly by you or through our partners as you prefer.",
            },
        ],
    },
    {
        title: "Stay & Accommodation",
        items: [
            {
                q: "Where will I stay in Kerala?",
                a: "We coordinate accommodation options to suit your budget and needs — from hotels to serviced apartments — working with trusted local partners.",
            },
            {
                q: "Can my family stay with me?",
                a: "Yes. Many patients travel with a companion or family member, and accommodation arrangements are coordinated for them as part of your journey support.",
            },
            {
                q: "How far is accommodation from the hospital?",
                a: "Accommodation options are chosen with proximity to your hospital in mind. Exact options and distances are confirmed once your hospital is finalized.",
            },
        ],
    },
    {
        title: "Medical Care",
        items: [
            {
                q: "Is UniversHeal a hospital?",
                a: "No. We are a healthcare coordination service. Medical care is delivered by independent, licensed hospitals and specialists in Kerala, and we coordinate your access to them.",
            },
            {
                q: "Who will treat me?",
                a: "Independent specialists and hospitals matched to your case. We coordinate appropriate options and support your decision — the choice always remains yours.",
            },
            {
                q: "Can I choose my own doctor or hospital?",
                a: "Of course. Share your preferences with us and we will coordinate availability, records and appointments with the provider you choose.",
            },
            {
                q: "What if I need specific tests or scans?",
                a: "Diagnostics and testing are coordinated with the relevant providers as part of your consultation and treatment planning.",
            },
        ],
    },
    {
        title: "Costs & Payments",
        items: [
            {
                q: "How much will my treatment cost?",
                a: "Costs vary by case, provider and treatment pathway. Before you commit to anything, we coordinate cost information and estimates from the relevant providers, so you can plan with clarity. Estimates are not guarantees.",
            },
            {
                q: "Do you charge for your services?",
                a: "[Fee structure — placeholder. This answer will describe our coordination fee model before launch.] Your initial enquiry is always welcome.",
            },
            {
                q: "How do payments work?",
                a: "Payments for treatment are made directly to the hospitals and providers caring for you. We guide you through the process and help coordinate the information you need.",
            },
        ],
    },
    {
        title: "Documents & Reports",
        items: [
            {
                q: "What documents should I bring?",
                a: "Your medical reports and scans, a list of current medicines, identification and travel documents, and any prior treatment records. We will give you a personalised checklist for your case.",
            },
            {
                q: "Can my reports be reviewed before I travel?",
                a: "Yes. After your enquiry, reports can be shared securely and specialist review of your case is coordinated — often the first step of your journey.",
            },
            {
                q: "How is my medical information protected?",
                a: "Your information is handled confidentially and shared only with the specialists and providers involved in coordinating your care. See our Privacy Policy for details.",
            },
        ],
    },
    {
        title: "During Your Stay",
        items: [
            {
                q: "Will someone help me at the hospital?",
                a: "Yes. A dedicated coordinator stays in contact during your treatment, helping with appointments, communication and practical support.",
            },
            {
                q: "I don't speak the local language. Is that a problem?",
                a: "No. Communication assistance is part of our coordination support, so you can speak with doctors and understand your care with confidence.",
            },
            {
                q: "Who arranges local transport?",
                a: "Airport pick-up, transfers and local transport are coordinated for you with verified local partners.",
            },
        ],
    },
    {
        title: "After Treatment",
        items: [
            {
                q: "What happens at discharge?",
                a: "Discharge is coordinated with your hospital, including medication information and clear recovery guidance, so nothing is left to chance.",
            },
            {
                q: "What follow-up happens after I return home?",
                a: "We coordinate follow-up consultations — including online consultations where appropriate — and stay available for recovery questions after you return home.",
            },
            {
                q: "Can I extend my recovery stay in Kerala?",
                a: "Yes. Recovery accommodation and support can be coordinated if your doctors recommend rest before flying.",
            },
        ],
    },
    {
        title: "Safety & Support",
        items: [
            {
                q: "Is my information confidential?",
                a: "Yes. We treat your information with strict confidentiality and share it only as needed to coordinate your care.",
            },
            {
                q: "What if something goes wrong during my stay?",
                a: "You always have a single point of contact. If any issue arises, we help coordinate a resolution with the relevant provider quickly.",
            },
            {
                q: "What about medical emergencies?",
                a: "UniversHeal is not an emergency service. If you are experiencing a medical emergency, contact your local emergency number or seek immediate care at the nearest emergency facility.",
            },
        ],
    },
    {
        title: "Others",
        items: [
            {
                q: "Do you help patients outside Kerala too?",
                a: "Our first market is Kerala, and our coordination model is designed to expand to other Indian cities over time. Today, care is coordinated in Kerala.",
            },
            {
                q: "How soon can treatment start?",
                a: "It depends on your case, the specialty and provider availability. The first step is a consultation — from there we help plan realistic timelines.",
            },
            {
                q: "Can I consult online before deciding to travel?",
                a: "Yes. Online consultations are often the first stage of the journey — you can meet a specialist and understand your options before making any travel decision.",
            },
        ],
    },
];

export const EXPLORE_LINKS = [
    { label: "Medical Care", path: "/medical-care" },
    { label: "Wellness", path: "/wellness" },
    { label: "Ayurveda", path: "/ayurveda" },
    { label: "Hospitals", path: "/hospitals" },
    { label: "Why UniversHeal", path: "/why-universheal" },
    { label: "Your Journey", path: "/your-journey" },
    { label: "Destinations", path: "/destinations" },
    { label: "Why Kerala", path: "/why-kerala" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
];

export const PATIENT_SERVICE_LINKS = [
    { label: "Get a Medical Opinion", path: "/get-a-medical-opinion" },
    { label: "Second Opinion", path: "/second-opinion" },
    { label: "Treatment Planning", path: "/treatment-planning" },
    { label: "Plan Your Wellness Journey", path: "/wellness" },
    { label: "Explore Ayurveda", path: "/ayurveda" },
    { label: "Travel & Accommodation", path: "/your-journey" },
    { label: "Follow-up Care", path: "/your-journey" },
    { label: "International Patient FAQ", path: "/faq" },
];

export const LEGAL_LINKS = [
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Terms of Use", path: "/terms-of-use" },
    { label: "Medical Disclaimer", path: "/medical-disclaimer" },
];

// PLACEHOLDER — replace with official social profiles before launch.
export const SOCIAL_LINKS = [
    { label: "LinkedIn", icon: "linkedin", href: "#" },
    { label: "Instagram", icon: "instagram", href: "#" },
    { label: "Facebook", icon: "facebook", href: "#" },
];

export const DISCLAIMER_TEXT =
    "UniversHeal coordinates access to healthcare services and does not itself diagnose or provide medical treatment unless expressly stated.";


// ---------- Specialty detail content (from lib/specialties.js) ----------
// Editorial detail content for each specialty page (template: SpecialtyDetail.js).
// UniversHeal coordinates access to care — it does not diagnose or treat.

const COORDINATES = [
    "Specialist consultation coordination",
    "Second opinion coordination",
    "Diagnostics and test coordination",
    "Hospital selection support",
    "Treatment planning",
    "Travel and accommodation support",
    "Recovery and follow-up coordination",
];

const SPECIALTY_DETAILS = {
    cardiology: {
        slug: "cardiology",
        name: "Cardiology",
        heroTitle: "Cardiology Care",
        heroAccent: "Expert care for a healthier, stronger heart.",
        intro:
            "Heart concerns deserve careful, well-coordinated attention. We connect you with experienced cardiac specialists in India and coordinate every practical step — from first consultation to recovery and follow-up.",
        image: "cardiology",
        imageAlt:
            "An Indian cardiologist reviewing a heart scan with an older international patient beside advanced cardiac equipment",
        conditionsTitle: "Conditions commonly supported",
        conditions: [
            "Coronary artery disease",
            "Heart failure",
            "Valve disorders",
            "Rhythm disorders (arrhythmias)",
            "Hypertension and preventive cardiology",
            "Paediatric cardiac concerns",
        ],
    },
    orthopaedics: {
        slug: "orthopaedics",
        name: "Orthopaedics",
        heroTitle: "Orthopaedic Care",
        heroAccent: "Move better. Live fuller.",
        intro:
            "From joint pain to complex spine concerns, orthopaedic decisions shape everyday life. We coordinate reviews of your imaging and reports, and opinions from experienced orthopaedic specialists in India.",
        image: "ortho",
        imageAlt:
            "An Indian orthopaedic specialist explaining an X-ray to an older international patient",
        conditionsTitle: "Conditions commonly supported",
        conditions: [
            "Knee and hip osteoarthritis",
            "Joint replacement opinions",
            "Spine and back concerns",
            "Sports injuries",
            "Shoulder, hand and wrist conditions",
            "Fracture and trauma follow-up",
        ],
    },
    oncology: {
        slug: "oncology",
        name: "Oncology",
        heroTitle: "Cancer Care",
        heroAccent: "Expert care. More tomorrows.",
        intro:
            "Oncology questions need sensitivity as much as precision. We provide structured, discreet coordination for oncology opinions and treatment planning in India — always at the pace that is right for you and your family.",
        image: "oncology",
        imageAlt:
            "An Indian oncologist speaking compassionately with an international patient in a calm modern cancer-care lounge",
        conditionsTitle: "Concerns commonly supported",
        conditions: [
            "New cancer diagnoses seeking specialist opinion",
            "Breast cancer care pathways",
            "Gastrointestinal cancer opinions",
            "Head and neck cancer concerns",
            "Blood cancer specialist liaison",
            "Second review of pathology and reports",
        ],
    },
    fertility: {
        slug: "fertility",
        name: "Fertility",
        heroTitle: "Fertility Care",
        heroAccent: "Expert support for new beginnings.",
        intro:
            "Fertility journeys are deeply personal. We coordinate discreet, compassionate access to fertility consultations and reproductive care in India, with support that respects your privacy at every step.",
        image: "fertility",
        imageAlt:
            "An Indian fertility specialist consulting with an international couple in a premium clinic",
        conditionsTitle: "Journeys commonly supported",
        conditions: [
            "Infertility assessments and opinions",
            "IVF and ICSI consultation coordination",
            "Recurrent miscarriage investigations",
            "PCOS and hormonal concerns",
            "Male fertility assessments",
            "Fertility preservation enquiries",
        ],
    },
};

const SPECIALTY_COORDINATION = COORDINATES;

export { SPECIALTY_DETAILS, SPECIALTY_COORDINATION };
